import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useStatuses() {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/job-statuses").then((r) => setList(r.data)).catch(() => {});
  }, []);
  return list;
}

export function useRoleNames() {
  const [list, setList] = useState([]);
  useEffect(() => {
    api.get("/roles").then((r) => setList(r.data.map((x) => x.name))).catch(() => {});
  }, []);
  return list;
}
